<script>
import PagesListView from '../PagesList.vue';

export default {
  components: {
    PagesListView: PagesListView,
  },
};
</script>

<template>
  <PagesListView post-header="Feed" post-type="feed" />
</template>
